import { useState } from 'react'
import { Trans } from 'react-i18next'

import quotes from '~/assets/images/sprite/quotes.svg'
import { Styles as SingleS } from '~/pages/onboarding/quizSingleChoice/libs/styles'
import { SvgImage } from '~/shared/components/SvgImage'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

import { Styles as S } from './styles'

export interface IEmojiRatingOption {
  key: string
  emoji: string
  fontSize: number
}

export interface IEmojiRatingScalePageProps extends TPageProps {
  ns: string
  question: string
  titleI18nKey: string
  options: readonly IEmojiRatingOption[]
  statementI18nKey?: string
  image?: {
    png: string
    webp: string
    alt: string
  }
}

export const EmojiRatingScalePage = ({
  nextPagePath,
  pageId,
  ns,
  question,
  titleI18nKey,
  options,
  statementI18nKey,
  image,
}: IEmojiRatingScalePageProps) => {
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <div>
          <S.Question>
            <Trans ns={ns} i18nKey={titleI18nKey} />
          </S.Question>

          {statementI18nKey && (
            <SingleS.StatementContainer>
              <SvgImage svg={quotes} width={16} />
              <SingleS.Statement>
                <Trans ns={ns} i18nKey={statementI18nKey} />
              </SingleS.Statement>
            </SingleS.StatementContainer>
          )}

          {image && (
            <S.ImageContainer>
              <picture>
                <source srcSet={image.webp} type="image/webp" />
                <img src={image.png} alt={image.alt} />
              </picture>
            </S.ImageContainer>
          )}
        </div>

        <S.EmojiRatingCard>
          {options.map(({ key, emoji, fontSize }) => (
            <S.EmojiButton
              key={key}
              type="button"
              $isSelected={answer === key}
              $fontSize={fontSize}
              disabled={isAnswersDisabled}
              onClick={() => {
                setAnswer(key)
                setIsAnswersDisabled(true)
                handleChange(key, handleContinue)
              }}
            >
              {emoji}
            </S.EmojiButton>
          ))}
        </S.EmojiRatingCard>
      </S.StyledContainer>
    </S.Root>
  )
}
